export default (editor) => {
  const listItemParent = editor.value.document.getParent(
    editor.value.focusBlock.key,
  );
  const ul = editor.value.document.getParent(listItemParent.key);
  editor.splitBlock(2);
  const parent = editor.value.document.getParent(editor.value.focusBlock.key);
  const moveToIndex = ul.nodes.indexOf(listItemParent) + 1;
  editor.moveNodeByKey(parent.key, ul.key, moveToIndex);
  if (listItemParent.nodes.toArray()[1]) {
    editor.moveNodeByKey(
      listItemParent.nodes.toArray()[1].key,
      editor.value.document.getParent(editor.value.focusBlock.key).key,
      1,
    );
  }
};
